<template>
  <v-app id="app" data-app="true">
    <router-view v-if="!layout"></router-view>
    <component v-else v-bind:is="layout"></component>
  </v-app>
</template>

<script>
import DefaultLayout from '@/ui/shared/components/Layouts/DefaultLayout.vue'
import EmptyLayout from '@/ui/shared/components/Layouts/EmptyLayout.vue'

export default {
  name: 'App',

  components: {
    DefaultLayout,
    EmptyLayout,
  },

  mounted() {
    this.$configureTracking()
  },

  computed: {
    layout() {
      return this.$route?.meta?.layout
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/main.scss';
</style>
